import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST, UPDATE_DOCTORS_PACKAGES_PAYMENT_REQUEST } from "./constants";
import { Action, DoctorPackageState } from "./types";

function items(state: DoctorPackageState = {}, action: Action): DoctorPackageState {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST):
      return action.payload;
    case getSuccessActionType(UPDATE_DOCTORS_PACKAGES_PAYMENT_REQUEST):
      return {
        ...state,
        data: state.data!.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload;
          }
          return item;
        }),
      };

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST:
      return true;
    case getSuccessActionType(FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST):
    case getFailureActionType(FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST):
      return false;

    default:
      return state;
  }
}

export const doctorsPackagesPayment = combineReducers({ items, isFetching });
